module.exports = __webpack_public_path__ + "static/media/B8.c70e5d41.svg";